module.exports = __webpack_public_path__ + "static/dynamic-logo-9e481be53110e61732cb1524c389ea03.mp4";